<template></template>

<script>
import { kitchenDrawerMethods } from '@state/helpers';

export default {
  data() {
    return {};
  },
  beforeMount() {
    this.$router.push({ name: 'login', params: { fromLogout: true } });
    this.toggleDrawer();
  },
  methods: {
    ...kitchenDrawerMethods,
  },
};
</script>

